module.exports = __webpack_public_path__ + "img/whatsapp-link.1d5ac9f3.svg";